import { BAYS } from '../../../../../constants';

import type { FAutocompleteOption } from '../../../../../components/baseV2';
import type { TreatmentServiceRowConfig } from './types';

export const TREATMENT_RICH_TEXT_MAX_LENGTH = 50000;
export const TREATMENT_DURATION_MIN_MONTHS = 1;
export const TREATMENT_DURATION_MAX_MONTHS = 99;
export const TREATMENT_ASSESSMENT_MAX_HOURS = 8;
export const TREATMENT_SERVICE_MAX_HOURS = 99;
export const TREATMENT_UNITS_PER_HOUR = 4;
export const TREATMENT_SERVICE_FIELD_HEIGHT = 40;
export const TREATMENT_PROPOSED_START_DATE_FORMAT = 'DD-MM-YYYY';
export const TREATMENT_PROVISIONING_REQUIRED_BAYS = [
  BAYS.BAY_2_6,
  BAYS.BAY_3,
  BAYS.BAY_6,
  BAYS.BAY_7,
] as const;

export const TREATMENT_SERVICE_FREQUENCY_OPTIONS: ReadonlyArray<FAutocompleteOption> = [
  { value: 'Weekly', label: 'Weekly' },
  { value: 'bi-weekly', label: 'Bi-weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: '6-months authorization period', label: '6 month authorization period' },
];

export const TREATMENT_SERVICE_ROWS: ReadonlyArray<TreatmentServiceRowConfig> = [
  {
    label: '97151 Assessment',
    hoursName: 'assessment_97151_hours',
    perName: 'assessment_97151_per',
    maxHours: TREATMENT_ASSESSMENT_MAX_HOURS,
    defaultPer: '6-months authorization period',
  },
  {
    label: '97152 Assisting Assessment',
    hoursName: 'assessment_97152_hours',
    perName: 'assessment_97152_per',
    maxHours: TREATMENT_ASSESSMENT_MAX_HOURS,
    defaultPer: '6-months authorization period',
  },
  {
    label: '97153 Direct ABA Technician 1:1',
    hoursName: 'direct_therapy_97153_hours',
    perName: 'direct_therapy_97153_per',
    maxHours: TREATMENT_SERVICE_MAX_HOURS,
    defaultPer: 'Weekly',
  },
  {
    label: '97155 Protocol Modification by BCBA',
    hoursName: 'protocol_modification_97155_hours',
    perName: 'protocol_modification_97155_per',
    maxHours: TREATMENT_SERVICE_MAX_HOURS,
    defaultPer: 'Weekly',
  },
  {
    label: '97156 Parent Training/Caregiver Support',
    hoursName: 'parent_training_97156_hours',
    perName: 'parent_training_97156_per',
    maxHours: TREATMENT_SERVICE_MAX_HOURS,
    defaultPer: 'Weekly',
  },
  {
    label: '97157 Group Parent Training (2–8 parents in a group setting)',
    hoursName: 'group_parent_training_97157_hours',
    perName: 'group_parent_training_97157_per',
    maxHours: TREATMENT_SERVICE_MAX_HOURS,
    defaultPer: 'Weekly',
  },
  {
    label: '99366 Care Coordination',
    hoursName: 'care_coordination_99366_hours',
    perName: 'care_coordination_99366_per',
    maxHours: TREATMENT_SERVICE_MAX_HOURS,
    defaultPer: 'Weekly',
  },
];
